import callApi from '../callApi';

export function deleteProfile(token) {
  return callApi({
    endpoint: `/customers/deletion/${token}`,
    options: { method: 'GET' },
  });
}
